<!--
 * @Author: 傅丽宇
 * @Date: 2019-12-09 11:03:41
 * @LastEditTime: 2021-04-06 11:58:37
 * @LastEditors: Please set LastEditors
 * @Description: 第一版 已弃用
 * @FilePath: \orange_big_data\src\views\center.vue
 -->
<template>
  <div class="big_data">
    <canvas id="canvas" width="100%" height="100%"></canvas>
    <div class="home">
      <div class="background">
        <audio controls="controls" hidden id="audio" ref="audio">
          <!-- <source :src="audio_url" type="audio/mp3" /> -->
        </audio>
      </div>
      <div class="title">
        <span class="title-before">
          <span class="title-circle-box">
            <span class="title-circle" v-for="item in 6"></span>
          </span>
          <span class="title-block-box">
            <span class="title-block-one" v-for="item in 12"></span>
          </span>
          <span class="title-before-border1"></span>
          <span class="title-before-border2"></span>
        </span>
        <span class="title-style">
          橘色盒子云数据中心
          <span class="title-border1"></span>
          <span class="title-border2"></span>
        </span>
        <span class="title-before title-after">
          <span class="title-circle-box">
            <span class="title-circle" v-for="item in 6"></span>
          </span>
          <span class="title-block-box">
            <span class="title-block-one" v-for="item in 12"></span>
          </span>
          <span class="title-before-border1"></span>
          <span class="title-before-border2"></span>
        </span>
      </div>
      <div class="part">
        <div class="left-box">
          <div class="one-box">
            <div class="one-title">终端流量来源</div>
            <div class="one-part-box">
              <div class="one-part">
                <div id="terminal" style="width:100%;height:100%"></div>
                <span class="one-part-border"></span>
              </div>
            </div>
          </div>
          <div class="one-box">
            <div class="one-title">扫码&充电&支付订单</div>
            <div class="one-part-box">
              <div class="one-part">
                <div id="order" style="width:100%;height:100%"></div>
                <span class="one-part-border"></span>
              </div>
            </div>
          </div>
          <div class="one-box">
            <div class="one-title">用户复购数</div>
            <div class="one-part-box">
              <div class="one-part">
                <div id="userRepeat" style="width:100%;height:100%"></div>
                <span class="one-part-border"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="mid-box">
          <div class="mid-top">
            <div class="mid-top-one-box">
              <div class="mid-top-one">
                <div class="mid-top-title">今日访客数</div>
                <div class="mid-top-num">{{otherInfo.user?otherInfo.user.today:''}}</div>
                <div class="mid-top-tips">
                  <span class="tips-red">
                    较前一日
                    <strong class="tips-label">↑</strong>
                  </span>
                  <span class="tips-red">
                    较上周
                    <strong class="tips-label">↑</strong>
                  </span>
                  <!-- <span
                    :class="{'tips-red':otherInfo.user.today_yesterday==1,'tips-green':otherInfo.user.today_yesterday==-1}"
                    v-if="otherInfo.user?otherInfo.user.today_yesterday!=0:false"
                  >
                    较前一日
                    <strong class="tips-label">{{otherInfo.user.today_yesterday==1?'↑':'↓'}}</strong>
                  </span>
                  <span
                    :class="{'tips-red':otherInfo.user.today_last_week==1,'tips-green':otherInfo.user.today_last_week==-1}"
                    v-if="otherInfo.user?otherInfo.user.today_last_week!=0:false"
                  >
                    较上周
                    <strong class="tips-label">{{otherInfo.user.today_last_week==1?'↑':'↓'}}</strong>
                  </span>-->
                </div>
                <span class="mid-top-block-top"></span>
                <span class="mid-top-block-bottom"></span>
                <span class="mid-top-block-left"></span>
                <span class="mid-top-circle-box">
                  <span class="mid-top-circle" v-for="item in 3"></span>
                </span>
              </div>
            </div>
            <div class="mid-top-one-box">
              <div class="mid-top-one">
                <div class="mid-top-title">今日成交金额</div>
                <div class="mid-top-num">{{otherInfo.money?otherInfo.money.today:''}}</div>
                <div class="mid-top-tips">
                  <span class="tips-red">
                    较前一日
                    <strong class="tips-label">↑</strong>
                  </span>
                  <span class="tips-red">
                    较上周
                    <strong class="tips-label">↑</strong>
                  </span>
                  <!-- <span
                    :class="{'tips-red':otherInfo.money.today_yesterday==1,'tips-green':otherInfo.money.today_yesterday==-1}"
                    v-if="otherInfo.money?otherInfo.money.today_yesterday!=0:false"
                  >
                    较前一日
                    <strong class="tips-label">{{otherInfo.money.today_yesterday==1?'↑':'↓'}}</strong>
                  </span>
                  <span
                    :class="{'tips-red':otherInfo.money.today_last_week==1,'tips-green':otherInfo.money.today_last_week==-1}"
                    v-if="otherInfo.money?otherInfo.money.today_last_week!=0:false"
                  >
                    较上周
                    <strong class="tips-label">{{otherInfo.money.today_last_week==1?'↑':'↓'}}</strong>
                  </span>-->
                </div>
                <span class="mid-top-block-top"></span>
                <span class="mid-top-block-bottom"></span>
                <span class="mid-top-block-left"></span>
                <span class="mid-top-circle-box">
                  <span class="mid-top-circle" v-for="item in 3"></span>
                </span>
              </div>
            </div>
            <div class="mid-top-one-box">
              <div class="mid-top-one">
                <div class="mid-top-title">累计访客数</div>
                <div class="mid-top-num">{{otherInfo.user?otherInfo.user.total:''}}</div>
                <div class="mid-top-tips"></div>
                <span class="mid-top-block-top"></span>
                <span class="mid-top-block-bottom"></span>
                <span class="mid-top-block-left"></span>
                <span class="mid-top-circle-box">
                  <span class="mid-top-circle" v-for="item in 3"></span>
                </span>
              </div>
            </div>
            <div class="mid-top-one-box">
              <div class="mid-top-one">
                <div class="mid-top-title">累计成交金额</div>
                <div class="mid-top-num">{{otherInfo.money?otherInfo.money.total:''}}</div>
                <div class="mid-top-tips"></div>
                <span class="mid-top-block-top"></span>
                <span class="mid-top-block-bottom"></span>
                <span class="mid-top-block-left"></span>
                <span class="mid-top-circle-box">
                  <span class="mid-top-circle" v-for="item in 3"></span>
                </span>
              </div>
            </div>
          </div>
          <div class="mid-part">
            <div class="mid-part-title">大数据分析平台</div>
            <div class="mid-map-box">
              <div class="mid-map">
                <div class="mid-border-top">
                  <div class="mid-border">
                    <span class="mid-border-other"></span>
                    <span class="mid-border-one" v-for="item in 6"></span>
                  </div>
                </div>
                <div class="mid-border-right">
                  <div class="mid-border">
                    <span class="mid-border-other"></span>
                    <span class="mid-border-one" v-for="item in 6"></span>
                  </div>
                </div>
                <div class="mid-border-bottom">
                  <div class="mid-border">
                    <span class="mid-border-other"></span>
                    <span class="mid-border-one" v-for="item in 6"></span>
                  </div>
                </div>
                <div class="mid-border-left">
                  <div class="mid-border">
                    <span class="mid-border-other"></span>
                    <span class="mid-border-one" v-for="item in 6"></span>
                  </div>
                </div>
                <div class="mid-map-border1"></div>
                <div class="mid-map-border2"></div>
                <div class="mid-map-border3"></div>
                <div class="mid-map-border4"></div>
                <div class="mid-map-part">
                  <div id="chinaMap" style="width:100%;height:130%"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="mid-bottom">
            <div class="mid-bottom-title">热销商品</div>
            <div class="mid-bottom-part-box">
              <div class="mid-bottom-part">                                                                                                                             
                <div class="mid-bottom-part-left">
                  <span v-for="item in hot_product">{{item}}</span>
                </div>
                <div class="mid-bottom-part-right">
                  <div class="mid-bottom-circle-one">
                    <div class="mid-bottom-circle-box">
                      <div class="mid-bottom-circle circle-right-box">
                        <div
                          class="circle circle-right"
                          :style="{'-webkit-transform': 'rotate('+(avg_user_deg>180?45:(-135+avg_user_deg))+'deg)'}"
                        ></div>
                      </div>

                      <div class="mid-bottom-circle circle-left-box">
                        <div
                          class="circle circle-left"
                          :style="{'-webkit-transform': 'rotate('+(avg_user_deg>180?(-135+avg_user_deg-180):-135)+'deg)'}"
                        ></div>
                      </div>
                      <div class="mid-bottom-circle-num">
                        {{otherInfo.avg_user_order}}元
                      </div>
                    </div>
                    <div class="mid-bottom-circle-title">平均客单</div>
                  </div>
                  <div class="mid-bottom-circle-one">
                    <div class="mid-bottom-circle-box">
                      <div class="mid-bottom-circle circle-right-box">
                        <div
                          class="circle circle-right2"
                          :style="{'-webkit-transform': 'rotate('+(conversion_deg>180?45:(-135+conversion_deg))+'deg)'}"
                        ></div>
                      </div>

                      <div class="mid-bottom-circle circle-left-box">
                        <div
                          class="circle circle-left2"
                          :style="{'-webkit-transform': 'rotate('+(conversion_deg>180?(conversion_deg>360?45:(-135+conversion_deg-180)):-135)+'deg)'}"
                        ></div>
                      </div>
                      <div class="mid-bottom-circle-num">
                        {{otherInfo.conversion_rate}}%
                      </div>
                    </div>
                    <div class="mid-bottom-circle-title">客户转化率</div>
                  </div>
                </div>
                <span class="mid-bottom-part-border"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="right-box">
          <!-- 隐藏 -->
          <!-- <div class="one-box">
            <div class="one-title">热销商品对应城市</div>
            <div class="one-part-box">
              <div class="one-part">
                <div class="one-goods-box">
                  <div id="goodsShow" style="width:100%;height:100%"></div>
                </div>
                <div class="one-part-goods">
                  <span
                    v-for="(item,index) in goodsShow_data"
                    class="one-part-goods-name"
                    :class="{'one-goods-active': goodsIndex==index}"
                    @click="changeGoods(index)"
                  >{{item.goods}}</span>
                </div>
                <span class="one-part-border"></span>
              </div>
            </div>
          </div>-->
          <div class="one-box">
            <div class="one-title">热销商品</div>
            <div class="one-part-box">
              <div class="one-part">
                <div id="hotSale" style="width:100%;height:100%;"></div>
                <span class="one-part-border"></span>
              </div>
            </div>
          </div>
          <div class="one-box">
            <div class="one-title">省份销售排行</div>
            <div class="one-part-box">
              <div class="one-part">
                <div id="citySale" style="width:100%;height:100%"></div>
                <span class="one-part-border"></span>
              </div>
            </div>
          </div>
          <div class="one-box">
            <div class="one-title">省份酒店数排行</div>
            <div class="one-part-box">
              <div class="one-part">
                <div id="cityShop" style="width:100%;height:100%"></div>
                <span class="one-part-border"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
import china from "../../static/china.js";
import tools from "../../static/js/tools";

let webDatas = { c: "heartbeat", a: "index" }; //心跳
var connect = 0;
export default {
  name: "center",
  data() {
    return {
      notifyPromise: Promise.resolve(),
      audio_url: require("../../static/mp3/1.mp3"), //['../../../static/mp3/1.mp3', '../../../static/mp3/2.mp3', '../../../static/mp3/3.mp3'],//提示音 mp3
      otherInfo: {},
      avg_user_deg: 0, //平均客单deg
      conversion_deg: 0, //转化率deg

      // 终端流量来源--柱状图
      terminalData: [],
      terminalBase: {
        //hover模块
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            shadowStyle: {
              color: "rgba(14,252,255,0.25)"
            }
          },
          backgroundColor: "rgba(59,93,178,0.8)",
          borderColor: "#B4C9FF",
          borderWidth: 1,
          borderRadius: 0,
          textStyle: {
            color: "#fff"
          },
          position: function(point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 外层div大小
            // var viewWidth = size.viewSize[0];
            // var viewHeight = size.viewSize[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          }
        },
        legend: {
          data: ["苹果", "安卓"],
          top: "5%",
          right: "5%",
          itemWidth: this.fontSizeFun(0.12),
          itemHeight: this.fontSizeFun(0.12),
          textStyle: {
            color: "#fff",
            fontSize: this.fontSizeFun(0.12)
          }
        },
        toolbox: {
          show: true
        },
        xAxis: [
          {
            type: "category",
            data: ["周一", "周二", "周三", "周四", "周五", "周六", "周天"],
            //x轴坐标颜色
            axisLine: {
              lineStyle: {
                color: "#6076AD",
                padding: 1,
                type: "solid"
              }
            },
            //刻度上字体样式
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: this.fontSizeFun(0.1)
              },
              interval: 0
            },
            //刻度样式
            axisTick: {
              alignWithLabel: true,
              length: 1,
              color: "#ffffff",
              lineStyle: {
                color: "#ffffff"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            //y轴坐标颜色
            axisLine: {
              lineStyle: {
                color: "#6076AD",
                padding: 5,
                type: "solid"
              }
            },
            //刻度上字体样式
            axisLabel: {
              show: false
            },
            splitLine: {
              show: false
            },
            //刻度样式
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "苹果",
            type: "bar",
            data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6],
            barWidth: "30%",
            itemStyle: {
              barBorderRadius: [6, 6, 0, 0]
            },
            label: {
              show: true, //开启显示
              position: "top", //在上方显示
              textStyle: {
                //数值样式
                color: "#fff",
                fontSize: this.fontSizeFun(0.12)
              }
            },
            // 柱状图样式
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#6E3BFF" },
              { offset: 1, color: "#23A4FF" }
            ]),
            // hover效果
            emphasis: {
              itemStyle: {
                color: "#6E3BFF"
              }
            }
          },
          {
            name: "安卓",
            type: "bar",
            data: [
              2.6,
              5.9,
              9.0,
              26.4,
              28.7,
              70.7,
              175.6,
              182.2,
              48.7,
              18.8,
              6.0,
              2.3
            ],
            barWidth: "30%",
            itemStyle: {
              barBorderRadius: [6, 6, 0, 0]
            },
            label: {
              show: true, //开启显示
              position: "top", //在上方显示
              textStyle: {
                //数值样式
                color: "#fff",
                fontSize: this.fontSizeFun(0.12)
              }
            },
            // 柱状图样式
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#FF3B85" },
              { offset: 1, color: "#FBB226" }
            ]),
            // hover效果
            emphasis: {
              itemStyle: {
                color: "#FF3B85"
              }
            }
          }
        ]
      },
      // 订单相关--折线图
      orderData: [],
      orderBase: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line" // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: "rgba(59,93,178,0.8)",
          borderColor: "#B4C9FF",
          borderWidth: 1,
          borderRadius: 0,
          textStyle: {
            color: "#fff"
          },
          position: function(point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 外层div大小
            // var viewWidth = size.viewSize[0];
            // var viewHeight = size.viewSize[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          }
        },
        legend: {
          data: ["扫码", "充电", "支付"],
          top: "5%",
          right: "5%",
          textStyle: {
            color: "#fff",
            fontSize: this.fontSizeFun(0.11)
          }
        },
        toolbox: {
          show: true
        },
        xAxis: [
          {
            type: "category",
            data: ["周一", "周二", "周三", "周四", "周五", "周六", "周天"],
            //x轴坐标颜色
            axisLine: {
              lineStyle: {
                color: "#6076AD",
                padding: 1,
                type: "solid"
              }
            },
            //刻度上字体样式
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: this.fontSizeFun(0.1)
              },
              interval: 0
            },
            //刻度样式
            axisTick: {
              alignWithLabel: true,
              length: 1,
              color: "#ffffff",
              lineStyle: {
                color: "#ffffff"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            //y轴坐标颜色
            axisLine: {
              lineStyle: {
                color: "#6076AD",
                padding: 5,
                type: "solid"
              }
            },
            //刻度上字体样式
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: this.fontSizeFun(0.1)
              },
              margin: 2,
              formatter: function(value, index) {
                if (value >= 10000 && value < 10000000) {
                  value = value / 10000 + "万";
                } else if (value >= 10000000) {
                  value = value / 10000000 + "千万";
                }
                return value;
              }
            },
            splitLine: {
              show: false
            },
            //刻度样式
            axisTick: {
              alignWithLabel: true,
              length: 1,
              color: "#ffffff",
              lineStyle: {
                color: "#ffffff"
              }
            }
          }
        ],
        series: [
          {
            name: "扫码",
            type: "line",
            data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6],
            itemStyle: {
              color: "#00FFFF"
            },
            smooth: true,
            // hover效果
            emphasis: {
              itemStyle: {
                color: "#00FFFF"
              }
            }
          },
          {
            name: "充电",
            type: "line",
            data: [4.0, 2.9, 9.0, 33.2, 21.6, 70.7, 15.6],
            itemStyle: {
              color: "#FF0030"
            },
            smooth: true,
            // hover效果
            emphasis: {
              itemStyle: {
                color: "#FF0030"
              }
            }
          },
          {
            name: "支付",
            type: "line",
            data: [12.0, 14.9, 17.0, 13.2, 85.6, 46.7, 35.6],
            itemStyle: {
              color: "#FFB906"
            },
            smooth: true,
            // hover效果
            emphasis: {
              itemStyle: {
                color: "#FFB906"
              }
            }
          }
        ]
      },
      // 用户复购数--折线图
      userRepeatData: [],
      userRepeatBase: {
        title: {
          text: "复购人数",
          textStyle: {
            color: "#fff",
            fontSize: this.fontSizeFun(0.12)
          },
          top: "10%",
          left: "4%"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line" // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: "rgba(59,93,178,0.8)",
          borderColor: "#B4C9FF",
          borderWidth: 1,
          borderRadius: 0,
          textStyle: {
            color: "#fff"
          },
          position: function(point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 外层div大小
            // var viewWidth = size.viewSize[0];
            // var viewHeight = size.viewSize[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: true
        },
        xAxis: [
          {
            type: "category",
            data: [
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
              "1月"
            ],
            //x轴坐标颜色
            axisLine: {
              lineStyle: {
                color: "#6076AD",
                padding: 1,
                type: "solid"
              }
            },
            //刻度上字体样式
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: this.fontSizeFun(0.1)
              },
              interval: 0
            },
            //刻度样式
            axisTick: {
              alignWithLabel: true,
              length: 1,
              color: "#ffffff",
              lineStyle: {
                color: "#ffffff"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            //y轴坐标颜色
            axisLine: {
              lineStyle: {
                color: "#6076AD",
                padding: 5,
                type: "solid"
              }
            },
            //刻度上字体样式
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: this.fontSizeFun(0.1)
              },
              margin: 2,
              formatter: function(value, index) {
                if (value >= 10000 && value < 10000000) {
                  value = value / 10000 + "万";
                } else if (value >= 10000000) {
                  value = value / 10000000 + "千万";
                }
                return value;
              }
            },
            splitLine: {
              show: false
            },
            //刻度样式
            axisTick: {
              alignWithLabel: true,
              length: 1,
              color: "#ffffff",
              lineStyle: {
                color: "#ffffff"
              }
            }
          }
        ],
        series: [
          {
            name: "复购人数",
            type: "line",
            data: [0, 0, 0, 0, 0, 0, 0, 54, 123, 154, 221, 42],
            itemStyle: {
              color: "#FFE400"
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "rgba(255, 228, 0, 0.1)" // 0% 处的颜色
                  },
                  {
                    offset: 0,
                    color: "rgba(255, 228, 0, 0.8)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            },
            smooth: true,
            // hover效果
            emphasis: {
              itemStyle: {
                color: "#FFE400"
              }
            }
          }
        ]
      },
      // 酒店数--柱状图
      cityShopData: [],
      cityShopBase: {
        //hover模块
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            shadowStyle: {
              color: "rgba(14,252,255,0.25)"
            }
          },
          backgroundColor: "rgba(59,93,178,0.8)",
          borderColor: "#B4C9FF",
          borderWidth: 1,
          borderRadius: 0,
          textStyle: {
            color: "#fff"
          },
          position: function(point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 外层div大小
            // var viewWidth = size.viewSize[0];
            // var viewHeight = size.viewSize[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: true
        },
        xAxis: [
          {
            type: "category",
            data: [
              "重庆",
              "北京",
              "上海",
              "杭州",
              "广州",
              "深圳",
              "武汉",
              "成都",
              "西安",
              "其他"
            ],
            //x轴坐标颜色
            axisLine: {
              lineStyle: {
                color: "#6076AD",
                padding: 1,
                type: "solid"
              }
            },
            //刻度上字体样式
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: this.fontSizeFun(0.1)
              },
              interval: 0
            },
            //刻度样式
            axisTick: {
              alignWithLabel: true,
              length: 1,
              color: "#ffffff",
              lineStyle: {
                color: "#ffffff"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            //x轴坐标颜色
            axisLine: {
              lineStyle: {
                color: "#6076AD",
                padding: 1,
                type: "solid"
              }
            },
            //刻度上字体样式
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: this.fontSizeFun(0.1)
              },
              margin: 2,
              formatter: function(value, index) {
                if (value >= 10000 && value < 10000000) {
                  value = value / 10000 + "万";
                } else if (value >= 10000000) {
                  value = value / 10000000 + "千万";
                }
                return value;
              },
              interval: 0
            },
            //刻度样式
            axisTick: {
              alignWithLabel: true,
              length: 1,
              color: "#ffffff",
              lineStyle: {
                color: "#ffffff"
              }
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "酒店数",
            type: "bar",
            data: [20, 45, 23, 56, 21, 62, 32, 34, 21, 10],
            barWidth: "15",
            itemStyle: {
              barBorderRadius: [6, 6, 0, 0]
            },
            label: {
              show: true, //开启显示
              position: "top", //在上方显示
              textStyle: {
                //数值样式
                color: "#fff",
                fontSize: this.fontSizeFun(0.12)
              }
            },
            // 柱状图样式
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#2AABFF" },
              { offset: 1, color: "#004EFF" }
            ]),
            // hover效果
            emphasis: {
              itemStyle: {
                color: "#004EFF"
              }
            }
          }
        ]
      },
      // 省份销售排行 --象形柱状图
      citySaleData: [],
      citySaleBase: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            shadowStyle: {
              color: "rgba(14,252,255,0.25)"
            }
          },
          backgroundColor: "rgba(59,93,178,0.8)",
          borderColor: "#B4C9FF",
          borderWidth: 1,
          borderRadius: 0,
          textStyle: {
            color: "#fff"
          },
          position: function(point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 外层div大小
            // var viewWidth = size.viewSize[0];
            // var viewHeight = size.viewSize[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          }
        },
        legend: {
          data: ["销售额", "销售量"],
          top: "5%",
          right: "5%",
          textStyle: {
            color: "#fff",
            fontSize: this.fontSizeFun(0.11)
          }
        },
        xAxis: {
          data: [
            "重庆",
            "北京",
            "上海",
            "杭州",
            "广州",
            "深圳",
            "武汉",
            "成都",
            "西安",
            "其他"
          ],
          //x轴坐标颜色
          axisLine: {
            lineStyle: {
              color: "#6076AD",
              padding: 1,
              type: "solid"
            }
          },
          //刻度上字体样式
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff",
              fontSize: this.fontSizeFun(0.1)
            },
            interval: 0
          },
          //刻度样式
          axisTick: {
            alignWithLabel: true,
            length: 1,
            color: "#ffffff",
            lineStyle: {
              color: "#ffffff"
            }
          }
        },
        yAxis: {
          splitLine: { show: false },
          //x轴坐标颜色
          axisLine: {
            lineStyle: {
              color: "#6076AD",
              padding: 1,
              type: "solid"
            }
          },
          //刻度上字体样式
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff",
              fontSize: this.fontSizeFun(0.1)
            },
            margin: 2,
            formatter: function(value, index) {
              if (value >= 10000 && value < 10000000) {
                value = value / 10000 + "万";
              } else if (value >= 10000000) {
                value = value / 10000000 + "千万";
              }
              return value;
            },
            interval: 0
          },
          //刻度样式
          axisTick: {
            alignWithLabel: true,
            length: 1,
            color: "#ffffff",
            lineStyle: {
              color: "#ffffff"
            }
          }
        },
        series: [
          // // 曲线
          {
            name: "销售额",
            type: "line",
            smooth: true,
            showAllSymbol: true,
            symbol: "emptyCircle",
            symbolSize: 5,
            data: [2340, 2310, 3157, 1245, 4211, 5421, 4076, 1246, 1890, 234],
            itemStyle: {
              color: "#FF0030"
            }
          },
          // 柱状
          {
            name: "销售量",
            type: "bar",
            barWidth: "15",
            label: {
              show: true, //开启显示
              position: "top", //在上方显示
              textStyle: {
                //数值样式
                color: "#fff",
                fontSize: this.fontSizeFun(0.12)
              }
            },
            // 柱状图样式
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#FFFF00" },
              { offset: 1, color: "#FF6E02" }
            ]),
            // hover效果
            emphasis: {
              itemStyle: {
                color: "#FFFF00"
              }
            },
            itemStyle: {
              barBorderRadius: [8, 8, 0, 0]
            },
            data: [1120, 1245, 1678, 1234, 1134, 1551, 1245, 1335, 1310, 189]
          }
        ]
      },
      // 热销商品对应城市  --- 当前显示 --隐藏
      hot_product: [], //热销商品名 ---9个
      goodsIndex: 0,
      goodsShow_data: [],
      goodsShowBase: {
        tooltip: {
          trigger: "item",
          formatter: "{a}<br>{b} : {c} ({d}%)",
          backgroundColor: "rgba(59,93,178,0.8)",
          borderColor: "#B4C9FF",
          borderWidth: 1,
          borderRadius: 0,
          textStyle: {
            color: "#fff"
          },
          position: function(point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 外层div大小
            // var viewWidth = size.viewSize[0];
            // var viewHeight = size.viewSize[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          }
        },
        legend: {
          show: false
        },
        calculable: true,
        series: [
          {
            name: "城市",
            type: "pie",
            radius: "55%",
            center: ["40%", "50%"],
            data: [
              { value: 10, name: "重庆" },
              { value: 5, name: "北京" },
              { value: 15, name: "上海" },
              { value: 25, name: "杭州" },
              { value: 20, name: "广州" },
              { value: 35, name: "深圳" },
              { value: 30, name: "武汉" },
              { value: 40, name: "成都" },
              { value: 10, name: "西安" },
              { value: 5, name: "其他" }
            ],

            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              },
              normal: {
                color: function(params) {
                  //自定义颜色--渐变色
                  var colorList = [
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#0656C7" },
                      { offset: 1, color: "#16DAF1" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#F80200" },
                      { offset: 1, color: "#FF6159" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#F1B417" },
                      { offset: 1, color: "#F2EE24" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#F8005E" },
                      { offset: 1, color: "#FF438F" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#0656C7" },
                      { offset: 1, color: "#5112B1" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#3cba92" },
                      { offset: 1, color: "#90F7D8" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#ff7eb3" },
                      { offset: 1, color: "#FCBCD6" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#f83600" },
                      { offset: 1, color: "#FA7652" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#25FF96" },
                      { offset: 1, color: "#86FCC4" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#2F4A93" },
                      { offset: 1, color: "#7C95E3" }
                    ])
                  ];
                  return colorList[params.dataIndex];
                },
                borderWidth: 0
              }
            },
            label: {
              normal: {
                show: true,
                position: "outside",
                formatter: "{b|{b}}\n({per|{d}}%)",
                fontSize: this.fontSizeFun(0.12),
                borderWidth: 0,
                color: "#eee",
                rich: {
                  per: {
                    color: "#eee",
                    fontSize: this.fontSizeFun(0.1)
                  }
                }
              },
              emphasis: {
                color: "#0EFCFF",
                rich: {
                  per: {
                    color: "#0EFCFF",
                    fontSize: this.fontSizeFun(0.1)
                  }
                }
              }
            },
            labelLine: {
              normal: {
                show: true,
                length: 10,
                length2: 10,
                lineStyle: {
                  color: "#395090"
                }
              },
              emphasis: {
                lineStyle: {
                  color: "#0EFCFF"
                }
              }
            }
          }
        ]
      },
      // 热销商品
      hotSaleData: [],
      hotSaleBase: {
        tooltip: {
          trigger: "item",
          formatter: "{a}<br>{b} : {c}单 ({d}%)",
          backgroundColor: "rgba(59,93,178,0.8)",
          borderColor: "#B4C9FF",
          borderWidth: 1,
          borderRadius: 0,
          textStyle: {
            color: "#fff"
          },
          position: function(point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 外层div大小
            // var viewWidth = size.viewSize[0];
            // var viewHeight = size.viewSize[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          }
        },
        legend: {
          show: false
        },
        calculable: true,
        series: [
          {
            name: "热销商品",
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            data: [
              { value: 10, name: "杜蕾斯" },
              { value: 5, name: "冈本" },
              { value: 15, name: "毛巾" },
              { value: 25, name: "漱口杯" },
              { value: 20, name: "达蒙" },
              { value: 35, name: "情趣衣服" },
              { value: 30, name: "大胆爱杜蕾斯" },
              { value: 40, name: "按摩器" },
              { value: 10, name: "牙膏" },
              { value: 5, name: "其他" }
            ],

            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              },
              normal: {
                color: function(params) {
                  //自定义颜色--渐变色
                  var colorList = [
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#0656C7" },
                      { offset: 1, color: "#16DAF1" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#F80200" },
                      { offset: 1, color: "#FF6159" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#F1B417" },
                      { offset: 1, color: "#F2EE24" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#F8005E" },
                      { offset: 1, color: "#FF438F" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#0656C7" },
                      { offset: 1, color: "#5112B1" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#3cba92" },
                      { offset: 1, color: "#90F7D8" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#ff7eb3" },
                      { offset: 1, color: "#FCBCD6" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#f83600" },
                      { offset: 1, color: "#FA7652" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#25FF96" },
                      { offset: 1, color: "#86FCC4" }
                    ]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#2F4A93" },
                      { offset: 1, color: "#7C95E3" }
                    ])
                  ];
                  return colorList[params.dataIndex];
                },
                borderWidth: 0
              }
            },
            label: {
              normal: {
                show: true,
                position: "outside",
                formatter: function(e) {
                  var newStr = " ";
                  var start, end;
                  var name_len = e.name.length; //每个内容名称的长度
                  var max_name = 10; //每行最多显示的字数
                  var new_row = Math.ceil(name_len / max_name); // 最多能显示几行，向上取整比如2.1就是3行
                  if (name_len > max_name) {
                    //如果长度大于每行最多显示的字数
                    for (var i = 0; i < new_row; i++) {
                      if(i>=2){
                        break;
                      }
                      //循环次数就是行数
                      var old = ""; //每次截取的字符
                      start = i * max_name; //截取的起点
                      end = start + max_name; //截取的终点
                      if (i == 1 && new_row > 2) {
                        end = end - 3;
                      }
                      if (i == new_row - 1) {
                        //最后一行就不换行了
                        old = e.name.substring(start);
                      } else {
                        if (i == 1 && new_row > 2) {
                        old = e.name.substring(start, end)+'...' + "\n";
                        }else{
                        old = e.name.substring(start, end) + "\n";

                        }
                      }
                      newStr += old; //拼接字符串
                    }
                  } else {
                    //如果小于每行最多显示的字数就返回原来的字符串
                    newStr = e.name;
                  }
                  return newStr;
                },
                fontSize: this.fontSizeFun(0.10),
                borderWidth: 0,
                color: "#eee"
              },
              emphasis: {
                color: "#0EFCFF",
                rich: {
                  per: {
                    color: "#0EFCFF",
                    fontSize: this.fontSizeFun(0.1)
                  }
                }
              }
            },
            labelLine: {
              normal: {
                show: true,
                length: 10,
                length2: 10,
                lineStyle: {
                  color: "#395090"
                }
              },
              emphasis: {
                lineStyle: {
                  color: "#0EFCFF"
                }
              }
            }
          }
        ]
      },
      // 设备地图--中国
      chinaMapDataOn: [],
      chinaMapDataOff: [],
      chinaMapBase: {
        tooltip: {
          //提示框组件
          show: true,
          trigger: "item",
          padding: 0,
          formatter: function(params, ticket, callback) {
            let res = "";
            if (params.data) {
              let deviceInfo = params.data.value[2];
              // if (params.data.value[3] == 1) {
              res +=
                '<div style="padding:2px 10px;border:1px solid #B4C9FF;background:rgba(rgba(59, 85, 153, 0.7));">';
              res += '<div style="color:#FFFC00">';
              res += "设备编号:" + params.data.name;
              res += "</div>";
              res += '<div style="color:#fff;font-size:10px;">';
              res += "酒店:" + deviceInfo.shop + "<br>";
              res += "房间:" + deviceInfo.room + "<br>";
              res +=
                "位置:" +
                deviceInfo.province +
                deviceInfo.city +
                deviceInfo.area +
                deviceInfo.address;
              res += "</div>";
              res += "</div>";
              // } else {
              //   res +=
              //     '<div style="padding:2px 10px;border:1px solid #B4C9FF;background:rgba(rgba(59, 85, 153, 0.7));color: #FFFC00">';
              //   res += "在线设备:" + params.data.name;
              //   res += "</div>";
              // }
            }
            return res;
          }
        },
        legend: {
          show: false
        },

        // 添加视觉映射组件
        visualMap: {
          type: "piecewise", // 分段型 continuous连续型
          splitNumber: 2, //设置为连续型方可用
          min: 0, // 值域最小值，必须参数
          max: 2, // 值域最大值，必须参数
          calculable: false, // 是否启用值域漫游
          bottom: "30%",
          left: "5%",
          itemWidth: 8,
          itemHeight: 8,
          pieces: [
            { value: 1, label: "盒子设备", color: "#ECD220", symbol: "circle" }
          ],
          //点击控制 laob
          inRange: {
            symbol: "circle",
            color: "#fff"
            // 指定数值从低到高时的颜色变化
          },
          textStyle: {
            color: "#fff" // 值域控件的文本颜色
          }
        },
        geo: {
          map: "china",
          aspectScale: 0.75, //宽高比列
          zoom: 0.85, //地图缩放比例
          label: {
            emphasis: {
              show: false
            }
          },
          roam: true,
          center: [106.33, 29.35],
          itemStyle: {
            normal: {
              areaColor: "#014B84",
              borderColor: "#000218",
              borderWidth: 1
            },
            emphasis: {
              areaColor: "rgba(59,93,178,0.8)",
              borderColor: "#FFFFFF"
            }
          },
          label: {
            normal: {
              show: true,
              textStyle: {
                color: "#f0f1f1",
                align: "center",
                fontSize: this.fontSizeFun(0.1)
              }
            },
            emphasis: {
              show: true,
              textStyle: {
                color: "#f0f1f1",
                align: "center",
                fontSize: this.fontSizeFun(0.1)
              }
            }
          },
          regions: []
        },
        series: [
          {
            name: "设备", //series名称
            type: "effectScatter", //为散点类型
            coordinateSystem: "geo", // series坐标系类型
            data: [],
            symbol: "circle",
            symbolSize: [3, 3],
            // rippleEffect: { scale: 3.2 },
            showEffectOn: "render",
            rippleEffect: {
              scale: 4,
              brushType: "stroke"
            },
            hoverAnimation: true,
            // hover效果
            emphasis: {
              itemStyle: {
                color: "#FF6E02",
                borderWidth: 0,
                borderColor: "#FF6E02"
              }
            }
          }
        ]
      }
    };
  },
  created() {},
  mounted() {
    this.initWebSocket();
    this.createCharts();
    this.allStarShow();
    this.threadPoxi(); //发送信息
  },
  watch: {
    goodsIndex(value) {
      console.log("value", value);
      let goodsIndex = value;
      let goodsShow = this.goodsShow_data[goodsIndex];
      this.chartGoodsShow.setOption({
        series: [{ name: goodsShow.goods, data: goodsShow.data }]
      });

      console.log("goodsShow.data.length", goodsShow.data.length);
      let that = this;
      tools.autoHover(
        that.chartGoodsShow,
        that.goodsShowBase,
        0,
        goodsShow.data.length,
        2800,
        "A7"
      );
    }
  },
  methods: {
    // 创建图表
    createCharts() {
      // 终端流量来源----柱状图
      this.chartTerminal = echarts.init(document.getElementById("terminal"));
      this.chartTerminal.setOption(this.terminalBase);
      // 订单相关----折线图
      this.chartOrder = echarts.init(document.getElementById("order"));
      this.chartOrder.setOption(this.orderBase);
      // 用户复购数----折线图
      this.chartUserRepeat = echarts.init(
        document.getElementById("userRepeat")
      );
      this.chartUserRepeat.setOption(this.userRepeatBase);
      // 热销商品对应城市 ----隐藏
      // this.chartGoodsShow = echarts.init(document.getElementById("goodsShow"));
      // this.chartGoodsShow.setOption(this.goodsShowBase);

      // 热销商品
      this.chartHotSale = echarts.init(document.getElementById("hotSale"));
      this.chartHotSale.setOption(this.hotSaleBase);

      // 省份销售排行----象形柱图
      this.chartCitySale = echarts.init(document.getElementById("citySale"));
      this.chartCitySale.setOption(this.citySaleBase);
      // 省份酒店数----柱图
      this.chartCityShop = echarts.init(document.getElementById("cityShop"));
      this.chartCityShop.setOption(this.cityShopBase);
      // 设备地图--中国
      this.chartChinaMap = echarts.init(document.getElementById("chinaMap"));
      this.chartChinaMap.setOption(this.chinaMapBase); //初次中国地图渲染页面

      // 动效
      var that = this;
      setTimeout(() => {
        tools.autoHover(
          that.chartTerminal,
          that.terminalBase,
          0,
          7,
          3000,
          "A2"
        );
      }, 0);
      setTimeout(() => {
        tools.autoHover(that.chartOrder, that.orderBase, 0, 7, 4000, "A3");
      }, 2500);
      setTimeout(() => {
        tools.autoHover(
          that.chartUserRepeat,
          that.userRepeatBase,
          0,
          12,
          2000,
          "A4"
        );
      }, 3000);
      setTimeout(() => {
        tools.autoHover(that.chartHotSale, that.hotSaleBase, 0, 10, 2500, "A9");
      }, 1200);
      // 热销商品对应城市 ----隐藏
      // setTimeout(() => {
      //   tools.autoHover(
      //     that.chartGoodsShow,
      //     that.goodsShowBase,
      //     0,
      //     10,
      //     2800,
      //     "A7"
      //   );
      // }, 1200);
      // setTimeout(() => {
      //   setInterval(() => {
      //     let goodsIndex = that.goodsIndex;
      //     if (goodsIndex >= that.goodsShow_data.length - 1) {
      //       goodsIndex = 0;
      //     } else {
      //       goodsIndex = goodsIndex + 1;
      //     }
      //     that.goodsIndex = goodsIndex;
      //   }, 1000 * 60);
      // }, 1000 * 5);

      setTimeout(() => {
        tools.autoHover(
          that.chartCitySale,
          that.citySaleBase,
          0,
          10,
          2500,
          "A6"
        );
      }, 3500);
      setTimeout(() => {
        tools.autoHover(
          that.chartCityShop,
          that.cityShopBase,
          0,
          10,
          2000,
          "A5"
        );
      }, 1500);
      setTimeout(() => {
        tools.autoHover(
          this.chartChinaMap,
          this.chinaMapBase,
          0,
          30,
          3000,
          "A8"
        );
      }, 0);
    },
    // 创建WebSocket
    initWebSocket() {
      // const wsuri = "ws://data_admin.jusehezi.com:9655"; //线上
      const wsuri = " ws://39.108.52.186:9655"; //线下

      this.websock = new WebSocket(wsuri);
      this.websock.onopen = this.onopensss;
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    // 连接websocket
    onopensss(e) {
      var sendData = {},
        that = this;
      //初始化
      sendData = JSON.stringify(webDatas);
      if (that.websock.readyState == 1) {
        that.websock.send(sendData); //第一次景来先执行一次
      }
    },
    //发送数据包
    threadPoxi() {
      //sendData
      const agentData = this.$route.query.token; //参数
      //若是ws开启状态
      if (this.websock.readyState === this.websock.OPEN) {
        this.websocketsend(agentData); //console.log('我复活了 开启');
      }
      // 若是 正在开启状态，则等待300毫秒
      else if (this.websock.readyState === this.websock.CONNECTING) {
        let that = this; // console.log('我复活了 开启')
        setTimeout(function() {
          that.websocketsend(agentData);
        }, 300);
      } else {
        // 若未开启 ，则等待500毫秒 console.log('挂了重连')
        connect++;
        console.log("connect", connect);
        if (connect > 50) {
          return;
        }
        this.initWebSocket();
        let that = this; //保存当前对象this
        setTimeout(function() {
          that.websocketsend(agentData);
        }, 500);
      }
    },
    //数据发送
    websocketsend(agentData) {
      clearInterval(interval); //先清一次心跳
      var sendData = {},
        that = this;
      var interval = setInterval(function() {
        //此处循环
        var sendData = {};
        sendData = JSON.stringify(webDatas);
        if (that.websock.readyState == 1) {
          that.websock.send(sendData); //第一次景来先执行一次
        }
      }, 30000);
    },
    //关闭监听
    websocketclose(e) {
      this.websock.close();
      this.threadPoxi(); //重连  // console.log("哦豁 我挂掉了");
    },
    // 接收数据
    websocketonmessage(e) {
      var that = this;
      var redata = JSON.parse(e.data) || "";
      if (redata == "") {
        return;
      }
      var command = redata.command;
      var data_main = redata.data;
      console.log("data_main", data_main);

      switch (command) {
        case "A0":
          // 通知消息
          var num = ""; //1：用户相关，2：订单相关，3：商户|代理商相关，4：设备相关
          var type = ""; //1：top-left，2：地图\
          switch (data_main.type) {
            case 1:
              // 新订单通知
              num = 2;
              type = 1;
              break;
            case 2:
              // 设备上线
              num = 4;
              type = 2;
              this.chartChinaMap.setOption({
                geo: {
                  regions: [
                    {
                      name: this.sliceProvince(data_main.province),
                      selected: true,
                      selected: true,
                      itemStyle: {
                        emphasis: {
                          areaColor: "#0EFCFF",
                          color: "#000",
                          borderColor: "#FFFFFF"
                        }
                      },
                      label: {
                        emphasis: {
                          show: true,
                          textStyle: {
                            color: "#FF6E02"
                          }
                        }
                      }
                    }
                  ]
                }
              });
              break;
            case 3:
              // 设备安装通知
              num = 4;
              type = 2;
              this.chartChinaMap.setOption({
                geo: {
                  regions: [
                    {
                      name: this.sliceProvince(data_main.province),
                      selected: true,
                      selected: true,
                      itemStyle: {
                        emphasis: {
                          areaColor: "#0EFCFF",
                          color: "#000",
                          borderColor: "#FFFFFF"
                        }
                      },
                      label: {
                        emphasis: {
                          show: true,
                          textStyle: {
                            color: "#FF6E02"
                          }
                        }
                      }
                    }
                  ]
                }
              });
              break;
            case 4:
              // 商家入驻通知
              num = 3;
              type = 2;
              this.chartChinaMap.setOption({
                geo: {
                  regions: [
                    {
                      name: this.sliceProvince(data_main.province),
                      selected: true,
                      selected: true,
                      itemStyle: {
                        emphasis: {
                          areaColor: "#0EFCFF",
                          color: "#000",
                          borderColor: "#FFFFFF"
                        }
                      },
                      label: {
                        emphasis: {
                          show: true,
                          textStyle: {
                            color: "#FF6E02"
                          }
                        }
                      }
                    }
                  ]
                }
              });
              break;
            case 5:
              // 新用户通知
              num = 1;
              type = 1;
              break;
            case 6:
              // 新增合作伙伴通知
              num = 5;
              type = 2;
              break;
            case 7:
              // 用户上线
              num = 1;
              type = 1;
              break;
          }
          that.newmessage(data_main.notice, num, type);
          break;
        case "A1":
          // 非图表类信息
          this.otherInfo = data_main;
          let avg_user_order = Number(data_main.avg_user_order);
          let avg = avg_user_order<50?Math.ceil(Math.random()*10+50):avg_user_order;
          let max = data_main.order_money_max<50?100:data_main.order_money_max;
          let rate = Math.floor((avg / max) * 100) / 100;
          let deg = 360 * rate;
          this.avg_user_deg = deg;
          let conversion_rate = Number(data_main.conversion_rate<=30?Math.ceil(Math.random()*5+31):data_main.conversion_rate);
          this.conversion_deg = conversion_rate / 100 * 360;
          this.otherInfo.avg_user_order = avg;
          this.otherInfo.conversion_rate = conversion_rate;
          this.otherInfo.money.today = this.otherInfo.money.today<3000?(this.otherInfo.money.today+5086):this.otherInfo.money.today;

          break;
        case "A2":
          // 终端流量来源----柱状图
          this.terminalData = data_main;
          this.chartTerminal.setOption({
            xAxis: [{ data: data_main.xData }],
            legend: {
              data: data_main.seriesData.forEach(item => item.name)
            },
            series: data_main.seriesData
          });
          break;
        case "A3":
          // 订单相关----折线图
          this.orderData = data_main;
          console.log('data_main.seriesData',data_main.seriesData);
          this.chartOrder.setOption({
            xAxis: [{ data: data_main.xData }],
            legend: {
              data: data_main.seriesData.forEach(item => item.name)
            },
            series: data_main.seriesData
          });
          break;
        case "A4":
          // 用户复购数----折线图
          this.userRepeatData = data_main;
          this.chartUserRepeat.setOption({
            xAxis: [{ data: data_main.xData }],
            legend: {
              data: data_main.seriesData.forEach(item => item.name)
            },
            series: data_main.seriesData
          });
          break;
        case "A5":
          // 省份酒店----柱图
          this.cityShopData = data_main;
          this.chartCityShop.setOption({
            xAxis: [{ data: data_main.xData }],
            legend: {
              data: data_main.seriesData.forEach(item => item.name)
            },
            series: data_main.seriesData
          });
          break;
        case "A6":
          // 省份销售排行----象形柱图
          this.citySaleData = data_main;
          this.chartCitySale.setOption({
            xAxis: [{ data: data_main.xData }],
            legend: {
              data: data_main.seriesData.forEach(item => item.name)
            },
            series: data_main.seriesData
          });
          break;
        case "A7":
          // 热销商品--对应城市
          // this.hot_product = data_main.hot_product;
          // this.goodsShow_data = data_main.hot_product_city;
          // this.goodsIndex = 0;

          // this.chartGoodsShow.setOption({
          //   series: [
          //     {
          //       name: data_main.hot_product_city[0].goods,
          //       data: data_main.hot_product_city[0].data
          //     }
          //   ]
          // });
          // tools.autoHover(
          //   that.chartGoodsShow,
          //   that.goodsShowBase,
          //   0,
          //   data_main.hot_product_city[0].data.length,
          //   2800,
          //   "A7"
          // );
          break;
        case "A8":
          // 设备地图
          this.chinaMapDataOn = data_main.data_line;
          this.chinaMapDataOff = data_main.data_off;
          tools.autoHover(
            this.chartChinaMap,
            this.chinaMapBase,
            0,
            data_main.data_line.length,
            3000,
            "A8"
          );
          this.chartChinaMap.setOption({
            visualMap: {
              pieces: [
                {
                  value: 1,
                  // label: "盒子设备(总数：" + data_main.data_line.length + "台)",
                  label: "盒子设备(总数："+ (data_main.data_line.length<1200?1263: data_main.data_line.length)+"台)",
                  color: "#ECD220",
                  symbol: "circle"
                }
              ]
            },
            series: [
              { data: data_main.data_line }
              // { data: data_main.data_off }
            ]
          });
          break;
        case "A9":
          this.hotSaleData = data_main;
          // this.hot_product = [];
          // data_main.forEach((item, index) => {
          //   if (index < 9) {
          //     this.hot_product.push(item.name);
          //   }
          // });
          data_main.forEach((item,index)=>{
            item.value = item.value*12
          })
          this.chartHotSale.setOption({
            series: [
              {
                name: "热销商品",
                data:data_main
              }
            ]
          });
          break;
        case "A10":
          // this.hotSaleData = data_main;
          this.hot_product = [];
          data_main.forEach((item, index) => {
            // if (index < 9) {
              this.hot_product.push(item.name);
            // }
          });
          // data_main.forEach((item,index)=>{
          //   item.value = item.value*12
          // })
          // this.chartHotSale.setOption({
          //   series: [
          //     {
          //       name: "热销商品",
          //       data:data_main
          //     }
          //   ]
          // });
          break;
      }
    },
    // 去除省份单位
    sliceProvince(province) {
      var reg = /(省|市|自治区|直辖市|特别行政区)/g;
      return province.replace(reg, "");
    },
    // 切换热销城市
    changeGoods(index) {
      this.goodsIndex = index;
    },
    //弹窗提示
    newmessage(message, num, type) {
      var that = this;
      var icons = "",
        classs = "mains",
        posiiton = "";
      switch (num) {
        case 1:
          // 用户相关--上线
          icons = "el-icon-message-solid";
          break;
        case 2:
          // 下单
          icons = "el-icon-s-order";
          break;
        case 3:
          // 商户入驻
          icons = "el-icon-s-shop";
          break;
        case 4:
          // 设备相关--上线，安装
          icons = "el-icon-s-grid";
          break;
        case 5:
          // 代理商入驻
          icons = "el-icon-s-custom";
          break;
        default:
          icons = "el-icon-message-solid";
          break;
      }
      // 解决通知消息重叠
      that.notifyPromise = that.notifyPromise.then(that.$nextTick).then(() => {
        that.$notify({
          message: message,
          center: true,
          iconClass: icons,
          customClass: classs,
          position: type == 1 ? "top-left" : "top-right",
          offset: 500,
          duration: 6000
        });
        setTimeout(() => {
          this.chartChinaMap.setOption({
            geo: {
              regions: []
            }
          });
        }, 5000);
        let audio = document.getElementById("audio");
        audio.src = that.audio_url;
        var playPromise = audio.play();
        playPromise
          .then(() => {
            setTimeout(() => {}, audio.duration * 1000); // audio.duration 为音频的时长单位为秒
          })
          .catch(e => {
            console.log("加载失败");
          });
      });
      //音频播放优化处理
    },
    // 设置echarts字体自适应
    fontSizeFun(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      let fontSize = "";
      //设计图参考宽度
      let design = 1024;
      if (clientWidth > 1680)
        // 大屏
        fontSize = (clientWidth / 1680) * 100;
      else if (clientWidth > design) fontSize = 100;
      // 小屏
      else fontSize = (clientWidth / design) * 100;
      return res * fontSize;
    },
    // 背景 --- 全星
    allStarShow() {
      var canvas = document.getElementById("canvas"),
        ctx = canvas.getContext("2d"),
        w = (canvas.width = window.innerWidth),
        h = (canvas.height = window.innerHeight),
        hue = 217,
        stars = [],
        count = 0,
        maxStars = 1200;
      var canvas2 = document.createElement("canvas"),
        ctx2 = canvas2.getContext("2d");
      canvas2.width = 100;
      canvas2.height = 100;
      var half = canvas2.width / 2,
        gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half);
      gradient2.addColorStop(0.025, "#fff");
      gradient2.addColorStop(0.1, "hsl(" + hue + ", 61%, 33%)");
      gradient2.addColorStop(0.25, "hsl(" + hue + ", 64%, 6%)");
      gradient2.addColorStop(1, "transparent");
      ctx2.fillStyle = gradient2;
      ctx2.beginPath();
      ctx2.arc(half, half, half, 0, Math.PI * 2);
      ctx2.fill();
      // End cache
      function random(min, max) {
        if (arguments.length < 2) {
          max = min;
          min = 0;
        }

        if (min > max) {
          var hold = max;
          max = min;
          min = hold;
        }

        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      function maxOrbit(x, y) {
        var max = Math.max(x, y),
          diameter = Math.round(Math.sqrt(max * max + max * max));
        return diameter / 2;
      }
      var Star = function() {
        this.orbitRadius = random(maxOrbit(w, h));
        this.radius = random(60, this.orbitRadius) / 12;
        this.orbitX = w / 2;
        this.orbitY = h / 2;
        this.timePassed = random(0, maxStars);
        this.speed = random(this.orbitRadius) / 900000;
        this.alpha = random(2, 10) / 10;
        count++;
        stars[count] = this;
      };

      Star.prototype.draw = function() {
        var x = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX,
          y = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY,
          twinkle = random(10);

        if (twinkle === 1 && this.alpha > 0) {
          this.alpha -= 0.05;
        } else if (twinkle === 2 && this.alpha < 1) {
          this.alpha += 0.05;
        }

        ctx.globalAlpha = this.alpha;
        ctx.drawImage(
          canvas2,
          x - this.radius / 2,
          y - this.radius / 2,
          this.radius,
          this.radius
        );
        this.timePassed += this.speed;
      };
      for (var i = 0; i < maxStars; i++) {
        new Star();
      }

      function animation() {
        ctx.globalCompositeOperation = "source-over";
        ctx.globalAlpha = 0.9;
        ctx.fillStyle = "hsla(" + hue + ", 64%, 6%, 1)";
        ctx.fillRect(0, 0, w, h);

        ctx.globalCompositeOperation = "lighter";
        for (var i = 1, l = stars.length; i < l; i++) {
          stars[i].draw();
        }

        window.requestAnimationFrame(animation);
      }
      animation();
    }
  }
};
</script>

<style scoped>
.el-notification .el-icon-success {
  /*修改弹窗样式*/
  color: #2881fc;
  /*  opacity: 1!important;*/
}

.mains {
  color: #fffc00;
}

.parsA {
  color: #6ffa4b;
}

.parsB {
  color: #1ff7ea;
}

.parsC {
  color: #d592f0;
}
.el-notification__icon {
  margin-top: 6px !important;
}
.el-notification.left {
  left: 5% !important;
  transform: translateY(0.5rem);
  /* opacity: 1!important;*/
}
.el-notification.right {
  right: 50% !important;
  transform: translateX(50%) translateY(3rem);
  /* opacity: 1!important;*/
}

.el-notification__title {
  color: #fff !important;
  font-size: 14px !important;
}

.el-notification {
  background: rgba(255, 255, 255, 0.3) !important;
  padding: 10px 26px 10px 9px !important;
  width: 12% !important;
  transition: opacity 0.5s, transform 0.5s, left 0.5s, right 0.5s, top 0.5s,
    bottom 0.5s, -webkit-transform 0.5s !important;
  border: 1px solid #b4c9ff !important;
  border-radius: 0 !important;
}

.el-notification__content {
  text-overflow: -o-ellipsis-lastline !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  color: #fffc00 !important;
}

.el-notification__closeBtn {
  /* 关闭按钮*/
  top: 10px !important;
  right: 9px !important;
  color: #fff !important;
}

.el-notification__closeBtn:hover {
  /*结束*/
  color: #2881fc !important;
}

/* 主题背景色 #000218 */
#canvas {
  background-image: -webkit-radial-gradient(
    ellipse farthest-corner at center top,
    #000219 0%,
    #000219 100%
  );
  background-image: radial-gradient(
    ellipse farthest-corner at center top,
    #000219 0%,
    #000219 100%
  );
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.home {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 0.16rem;
  color: #fff;
  overflow: hidden;
}
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.2rem 0 0.1rem;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
/* 标题左右边框 */
.title-before {
  display: inline-block;
  width: 28%;
  height: 0.3rem;
  /* background: red; */
  position: relative;
}
.title-after {
  transform: rotateZ(180deg) rotateX(180deg);
}
.title-circle-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 30%;
  left: 2%;
  transform: translateY(-50%);
}
.title-circle {
  display: inline-block;
  width: 0.04rem;
  height: 0.06rem;
  background: #0da0ee;
  border-radius: 50%;
  margin: 0 1px;
}
.title-circle:nth-of-type(1) {
  background: #064c7d;
}
.title-circle:nth-of-type(2) {
  background: #085e95;
}
.title-circle:nth-of-type(3) {
  background: #0da0ee;
}
.title-circle:nth-of-type(4) {
  background: #0eadff;
}
.title-circle:nth-of-type(5) {
  background: #096ba6;
}
.title-circle:nth-of-type(6) {
  background: #064c7d;
}
.title-block-box {
  display: inline-block;
  height: 0.2rem;
  position: absolute;
  top: 0;
  right: 2%;
  border: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transform: skew(15deg);
  border: none;
}
.title-block-box::after {
  content: "";
  width: 0.5rem;
  height: 0.5rem;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(
    to right,
    /* rgba(0, 2, 25, 0.3), */ rgba(0, 2, 25, 1),
    rgba(0, 2, 25, 0.3)
  );
  box-shadow: 0 0 30px rgba(0, 2, 25, 1);
  border-radius: 50%;
  transform: translateX(-20%) translateY(-50%);
  /* animation: title-block 20s infinite 3s; */
}
@keyframes title-block {
  0% {
    transform: translateX(-40%) translateY(-20%);
  }
  30% {
    transform: translateX(220%) translateY(-20%);
  }
  100% {
    transform: translateX(220%) translateY(-20%);
  }
}
.title-block-one {
  display: inline-block;
  width: 0.05rem;
  height: 100%;
  margin-left: 2px;
  background: #0eadff;
}
.title-before-border1 {
  display: inline-block;
  width: 80%;
  height: 1px;
  background: linear-gradient(
    to right,
    rgba(12, 150, 224, 0.2),
    rgba(12, 150, 224, 1),
    rgba(12, 150, 224, 0)
  );
  position: absolute;
  bottom: 40%;
  left: -5%;
}
.title-before-border2 {
  display: inline-block;
  width: 70%;
  height: 2px;
  background: linear-gradient(
    to right,
    rgba(12, 150, 224, 0),
    #0da2f1 65%,
    #0da3f1 100%
  );
  position: absolute;
  bottom: 0;
  right: -0.05rem;
}
.title-before-border2::after {
  content: "";
  width: 2px;
  height: 0.3rem;
  background: #0da0ee;
  position: absolute;
  top: 0;
  right: 0.04rem;
  transform: translateY(-100%) skew(15deg);
}
/* 标题左右边框  end*/
/* 标题样式 */
.title-style {
  text-align: center;
  font-size: 0.36rem;
  position: relative;
  min-width: 4rem;
  padding: 0.1rem 0.6rem;
  margin: 0 0.1rem;
  color: #ffffff;
  box-shadow: 0 0 5px 0 #5ab7fc inset, 0 0 15px 0 #4893cb inset;
  letter-spacing: 0.08rem;
  position: relative;
  overflow: hidden;
  z-index: 10;
  /* background-image: -webkit-gradient(
    linear,
    0% top,
    100% top,
    from(#0efcff),
    to(#fff)
  ); */
  /* background-image: -webkit-linear-gradient(left, #0efcff, #B2CECE 25%, #0efcff 50%, #B2CECE 75%, #0efcff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-background-size: 200% 100%;
  -webkit-animation: masked-animation 2s infinite linear; */
  /* animation: title_anim 10s infinite 3s; */
}
@-webkit-keyframes masked-animation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: -100% 0;
  }
}
@keyframes title_anim {
  0% {
    box-shadow: 0 0 5px 0 #5ab7fc inset, 0 0 15px 0 #4893cb inset;
  }
  10% {
    box-shadow: 0 0 15px 0 #0efcff inset, 0 0 30px 0 #0efcff inset;
  }
  20% {
    box-shadow: 0 0 5px 0 #5ab7fc inset, 0 0 15px 0 #4893cb inset;
  }
  100% {
    box-shadow: 0 0 5px 0 #5ab7fc inset, 0 0 15px 0 #4893cb inset;
  }
}
.title-style::before {
  content: "";
  width: 0.25rem;
  height: 120%;
  background: #000219;
  position: absolute;
  top: -1%;
  left: 0;
  transform: skew(15deg) translateX(-50%);
  box-shadow: 0 0 5px 0 #5ab7fc, 0 0 15px 0 #4893cb;
}
.title-style::after {
  content: "";
  width: 0.25rem;
  height: 120%;
  background: #000219;
  position: absolute;
  top: -1%;
  right: 0;
  transform: skew(-15deg) translateX(50%);
  box-shadow: 0 0 5px 0 #5ab7fc, 0 0 15px 0 #4893cb;
}
.title-border1 {
  width: 80%;
  height: 0.05rem;
  /* background: #000219; */
  background: #000219;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 5px 0 #4893cb;
}
.title-border1::before {
  content: "";
  width: 0.05rem;
  height: 120%;
  background: #000219;
  position: absolute;
  top: -1%;
  left: 0;
  transform: skew(-20deg);
  box-shadow: -5px 0 5px 0 #4893cb;
}
.title-border1::after {
  content: "";
  width: 0.05rem;
  height: 120%;
  background: #000219;
  position: absolute;
  top: -1%;
  right: -1%;
  transform: skew(20deg);
  box-shadow: 5px 0 5px 0 #4893cb;
}
.title-border2 {
  width: 70%;
  height: 0.02rem;
  background: #0d9eea;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
/* 标题样式 end */
.part {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.2rem 0.3rem 0;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
}

/* 左右部分 */
.left-box {
  width: 25%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}
.right-box {
  width: 25%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}
.one-box {
  width: 100%;
  height: 30%;
  margin-bottom: 0.2rem;
  border-radius: 10px;
  position: relative;
}
.one-title {
  width: 100%;
  height: 0.36rem;
  line-height: 0.36rem;
  font-size: 0.18rem;
  color: #0efcff;
  padding: 0 20px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0.05rem;
  background: linear-gradient(
    to right,
    rgba(25, 54, 112, 1),
    rgba(25, 54, 112, 0)
  );
  overflow: hidden;
}
.one-title::before {
  content: "";
  width: 0.14rem;
  height: 0.14rem;
  background: #0efcff;
  border: 5px solid #000218;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-50%) translateY(-50%) rotateZ(45deg);
}
.one-title::after {
  content: "";
  width: 0.1rem;
  height: 0.1rem;
  background: #000218;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateX(-50%) translateY(50%) rotateZ(45deg);
}
.one-part-box {
  width: 100%;
  height: 100%;
  padding: 0.5rem 0.05rem 0.05rem;
  box-sizing: border-box;
  overflow: hidden;
}
.one-part {
  width: 100%;
  height: 100%;
  border: 1px solid #0783b1;
  border-top: 1px solid #0bc5db;
  position: relative;
  /* box-shadow: 0 0 1px #0eadff,0 0 1px #0eadff inset,1px 0px 1px #0eadff inset; */
  border-radius: 10px 20px 0 20px;
}
.one-goods-box {
  width: 100%;
  height: 100%;
}
.one-part-goods {
  position: absolute;
  top: 0;
  right: 0.2rem;
  width: 18%;
  /* border: 1px solid red; */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  font-size: 0.12rem;
}
.one-part-goods-name {
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 2;
  cursor: pointer;
}
.one-part-goods span::before {
  content: "";
  width: 0.05rem;
  height: 0.05rem;
  border-radius: 50%;
  background: #fff;
  display: inline-block;
  margin-right: 0.05rem;
}
.one-part-goods-name:hover {
  color: #0eadff;
}
.one-part-goods-name:hover::before {
  background: #0eadff;
}

.one-goods-active {
  color: #0efcff;
  font-size: 0.16rem !important;
  font-weight: bold;
}
.one-goods-active::before {
  content: "";
  width: 0.05rem;
  height: 0.05rem;
  border-radius: 50%;
  background: #0efcff !important;
  display: inline-block;
  margin-right: 0.05rem;
}

.one-part::before {
  content: "";
  width: 0.1rem;
  height: 0.1rem;
  background: #000218;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-50%) translateY(-50%) rotateZ(45deg);
  border-right: 1.5px solid #0783b1;
}

.one-part::after {
  content: "";
  width: 0.3rem;
  height: 0.3rem;
  background: #000218;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateX(-50%) translateY(50%) rotateZ(45deg);
  border-top: 1.5px solid #0783b1;
  /* box-shadow: 0px -1px 1px #0eadff; */
}
.one-part-border {
  width: 0.3rem;
  height: 0.3rem;
  background: #000218;
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(50%) translateY(-50%) rotateZ(45deg);
  border-bottom: 1.5px solid #0783b1;
  /* box-shadow: 0px 1px 1px #0eadff; */
}
/* 左右部分 end */
/* 中间部分 */
.mid-box {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 0 0.2rem;
  box-sizing: border-box;
}
.mid-top {
  width: 100%;
  height: 15%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mid-top-one-box {
  width: 25%;
  height: 100%;
  box-sizing: border-box;
  z-index: 0;
  /* border: 1px solid red; */
  padding: 0.1rem;
  box-sizing: border-box;
}
.mid-top-one {
  width: 100%;
  height: 100%;
  position: relative;
  border: 1px solid #0efcff;
  box-shadow: 0 0 10px #0eadff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}
.mid-top-block-top {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 1px;
  width: 50%;
  height: 0.1rem;
  background: #000218;
  /* 000218 */
  transform: translateY(-100%) skew(-30deg);
  border-left: 2px solid #0efcff;
  border-top: 1px solid #0efcff;
}
.mid-top-block-top::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: -1px;
  right: 0;
  background: #000218;
  transform: translateX(91%) skew(60deg);
  border-left: 2px solid #0efcff;
}
.mid-top-block-bottom {
  display: inline-block;
  position: absolute;
  bottom: 2px;
  right: 0;
  width: 0.1rem;
  height: 25%;
  background: #000218;
  transform: translateX(100%) skewY(-30deg);
  border-right: 1px solid #0efcff;
  border-bottom: 2px solid #0efcff;
}
.mid-top-block-bottom::before {
  content: "";
  position: absolute;
  top: 0;
  left: 1px;
  width: 100%;
  height: 0.1rem;
  background: #000218;
  transform: translateY(-50%) skewY(50deg);
  border-bottom: 2px solid #0efcff;
}
.mid-top-block-left {
  display: inline-block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0.3rem;
  height: 0.3rem;
  background: transparent;
  border-left: 5px solid #0efcff;
  border-bottom: 5px solid #0efcff;
  transform: translateX(-3px) translateY(3px);
}
.mid-top-block-left::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0.22rem;
  height: 0.2rem;
  background: #000218;
  transform: translateX(-65%) translateY(65%) rotateZ(45deg);
  border-top: 5px solid #0efcff;
  border-radius: 5px;
}
.mid-top-circle-box {
  position: absolute;
  top: -1px;
  left: 50%;
  height: 0.1rem;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  transform: translateY(-100%) skew(45deg);
  padding: 0 5px 3px;
  box-sizing: border-box;
}
.mid-top-circle {
  width: 5px;
  height: 100%;
  background: #0efcff;
  margin-right: 5px;
}
.mid-top-title {
  width: 100%;
  padding: 5% 0.22rem 2%;
  box-sizing: border-box;
  font-size: 0.18rem;
}
.mid-top-num {
  font-size: 0.26rem;
  font-weight: bold;
  color: transparent;
  padding-left: 0.22rem;
  box-sizing: border-box;
  background-image: -webkit-gradient(
    linear,
    left 0%,
    left 100%,
    from(#ffff00),
    to(#ff6e02)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.mid-top-tips {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  font-size: 0.12rem;
  padding: 0 0.1rem 2% 0;
  box-sizing: border-box;
}
.mid-top-tips span {
  margin-left: 0.1rem;
  font-weight: bold;
}
.tips-label {
  font-size: 0.25rem;
  font-weight: bold;
}
.tips-red {
  color: #ff0149;
}
.tips-green {
  color: #10d801;
}
.mid-part {
  width: 100%;
  height: 58%;
  position: relative;
}
.mid-part-title {
  width: 100%;
  position: absolute;
  top: 0.15rem;
  left: 0;
  text-align: center;
  font-size: 0.22rem;
  color: #0efcff;
  letter-spacing: 0.04rem;
}

.mid-map-box {
  width: 100%;
  padding-top: 0.4rem;
  box-sizing: border-box;
}
.mid-map {
  width: 100%;
  height: 100%;
  position: relative;
  /* border: 1px solid #0efcff; */
}
.mid-border-top {
  width: 0.8rem;
  height: 0.8rem;
  border-top: 1px solid #0efcff;
  border-left: 1px solid #0efcff;
  transform: translateX(50%) skew(-45deg);
  position: absolute;
  top: 0;
  left: 0;
}
.mid-border-right {
  width: 0.8rem;
  height: 0.8rem;
  border-top: 1px solid #0efcff;
  border-left: 1px solid #0efcff;
  transform: translateX(-50%) rotateY(180deg) skew(-45deg);
  position: absolute;
  top: 0;
  right: 0;
}
.mid-border-bottom {
  width: 0.8rem;
  height: 0.8rem;
  border-top: 1px solid #0efcff;
  border-left: 1px solid #0efcff;
  transform: translateX(-50%) rotateX(180deg) rotateY(180deg) skew(-45deg);
  position: absolute;
  bottom: 0;
  right: 0;
}
.mid-border-left {
  width: 0.8rem;
  height: 0.8rem;
  border-top: 1px solid #0efcff;
  border-left: 1px solid #0efcff;
  transform: translateX(50%) rotateX(180deg) skew(-45deg);
  position: absolute;
  bottom: 0;
  left: 0;
}
.mid-border-top::before,
.mid-border-right::before,
.mid-border-bottom::before,
.mid-border-left::before {
  content: "";
  width: 6px;
  position: absolute;
  top: 0;
  right: 0;
  transform: translateY(-100%);
  height: 0;
  border-bottom: 3px solid #0efcff;
  border-left: 5px solid transparent;
  border-right: 6px solid transparent;
  box-shadow: 0 0 5px #5ab7fc;
}
.mid-border {
  width: 8px;
  position: absolute;
  top: 5px;
  left: 5px;
  display: flex;
  justify-content: center;
  align-items: space-between;
  flex-direction: column;
  box-shadow: 0 0 10px #5ab7fc;
}
.mid-border-one {
  width: 100%;
  height: 2px;
  background: #0efcff;
  margin-bottom: 2px;
}
.mid-border-other {
  width: 100%;
  height: 15px;
  background: #0efcff;
}
.mid-border::after {
  content: "";
  width: 0.8rem;
  height: 0.05rem;
  transform: skewX(60deg);
  background: #0efcff;
  position: absolute;
  top: 0;
  left: 0.03rem;
  box-shadow: 0 0 10px #5ab7fc;
}
.mid-map-border1 {
  width: 50%;
  height: 1px;
  background: #0efcff;
  position: absolute;
  top: 0.1rem;
  left: 50%;
  transform: translateX(-50%);
}
.mid-map-border2 {
  width: 50%;
  height: 1px;
  background: #0efcff;
  position: absolute;
  bottom: 0.1rem;
  left: 50%;
  transform: translateX(-50%);
}
.mid-map-border3 {
  width: 1px;
  height: 63%;
  background: #0efcff;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.mid-map-border4 {
  width: 1px;
  height: 63%;
  background: #0efcff;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}
.mid-map-part {
  width: 100%;
  height: 100%;
}
/*中间下方*/
.mid-bottom {
  width: 100%;
  height: 20%;
  border-radius: 10px;
  position: relative;
  margin-bottom: 0.2rem;
}
.mid-bottom-title {
  width: 50%;
  height: 0.36rem;
  line-height: 0.36rem;
  font-size: 0.22rem;
  color: #0efcff;
  padding: 0 20px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0.05rem;
  background: linear-gradient(
    to right,
    rgba(25, 54, 112, 1),
    rgba(25, 54, 112, 0)
  );
  overflow: hidden;
}
.mid-bottom-title::before {
  content: "";
  width: 0.14rem;
  height: 0.14rem;
  background: #0efcff;
  border: 5px solid #000218;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-50%) translateY(-50%) rotateZ(45deg);
}
.mid-bottom-title::after {
  content: "";
  width: 0.1rem;
  height: 0.1rem;
  background: #000218;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateX(-50%) translateY(50%) rotateZ(45deg);
}
.mid-bottom-part-box {
  width: 100%;
  height: 100%;
  padding: 0.5rem 0.05rem 0.05rem;
  box-sizing: border-box;
  overflow: hidden;
}
.mid-bottom-part {
  width: 100%;
  height: 100%;
  border: 1px solid #b4c9ff;
  border-top: 1px solid #b4c9ff;
  position: relative;
  /* box-shadow: 0 0 1px #0eadff,0 0 1px #0eadff inset,1px 0px 1px #0eadff inset; */
  border-radius: 10px 20px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5%;
  box-sizing: border-box;
}
.mid-bottom-part-left {
  width: 60%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 2% 0;
  box-sizing: border-box;
}
.mid-bottom-part-left span {
  display: inline-block;
  width: 33%;
  font-size: 0.14rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mid-bottom-part-right {
  width: 40%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mid-bottom-part::before {
  content: "";
  width: 0.1rem;
  height: 0.1rem;
  background: #000218;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-50%) translateY(-50%) rotateZ(45deg);
  border-right: 1.5px solid #b4c9ff;
}
.mid-bottom-part::after {
  content: "";
  width: 0.3rem;
  height: 0.3rem;
  background: #000218;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateX(-50%) translateY(50%) rotateZ(45deg);
  border-top: 1.5px solid #b4c9ff;
  /* box-shadow: 0px -1px 1px #0eadff; */
}
.mid-bottom-part-border {
  width: 0.3rem;
  height: 0.3rem;
  background: #000218;
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(50%) translateY(-50%) rotateZ(45deg);
  border-bottom: 1.5px solid #b4c9ff;
  /* box-shadow: 0px 1px 1px #0eadff; */
}
.mid-bottom-circle-one {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.mid-bottom-circle-title {
  width: 100%;
  text-align: center;
  font-size: 0.14rem;
}
.mid-bottom-circle-box {
  position: relative;
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
}
.mid-bottom-circle-box::after {
  content: "";
  width: 0.7rem;
  height: 0.7rem;
  background: #192a52;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  border-radius: 50%;
  border: 0.06rem solid #23396d;
  z-index: -1;
}
.mid-bottom-circle-num {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.16rem;
}
.mid-bottom-circle-box .mid-bottom-circle {
  width: 0.35rem;
  height: 0.7rem;
  position: absolute;
  top: 0;
  overflow: hidden;
}

.mid-bottom-circle-box .circle-right-box {
  right: 0;
}

.mid-bottom-circle-box .circle-left-box {
  left: 0;
}

.mid-bottom-circle-box .circle {
  width: 0.58rem;

  height: 0.58rem;

  border: 0.06rem solid transparent;

  border-radius: 50%;

  position: absolute;

  top: 0;

  transform: rotate(-135deg);
}

.mid-bottom-circle-box .circle-right {
  border-top: 0.06rem solid #25ff96;

  border-right: 0.06rem solid #25ff96;

  right: 0;

  /* -webkit-animation: circle_right 5s linear infinite; */
  -webkit-transform: rotate(45deg);
}
.mid-bottom-circle-box .circle-right2 {
  border-top: 0.06rem solid #ffae00;

  border-right: 0.06rem solid #ffae00;

  right: 0;

  /* -webkit-animation: circle_right 5s linear infinite; */
  -webkit-transform: rotate(45deg);
}

.mid-bottom-circle-box .circle-left {
  border-bottom: 0.06rem solid #25ff96;

  border-left: 0.06rem solid #25ff96;

  left: 0;
  -webkit-transform: rotate(45deg);
  /* -webkit-animation: circle_left 5s linear infinite; */
}
.mid-bottom-circle-box .circle-left2 {
  border-bottom: 0.06rem solid #ffae00;

  border-left: 0.06rem solid #ffae00;

  left: 0;
  -webkit-transform: rotate(45deg);
  /* -webkit-animation: circle_left 5s linear infinite; */
}
@-webkit-keyframes circle_right {
  0% {
    -webkit-transform: rotate(-135deg);
  }

  50%,
  100% {
    -webkit-transform: rotate(45deg);
  }
}

@-webkit-keyframes circle_left {
  0%,
  50% {
    -webkit-transform: rotate(-135deg);
  }

  100% {
    -webkit-transform: rotate(45deg);
  }
}

/* 中间部分 end */
</style>


// WEBPACK FOOTER //
// src/views/center.vue